import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { t } from '../../lib/i18n';
import { Navbar } from '../layout/Navbar';
import { Button } from '../ui/button';
import {
  LayoutDashboard,
  Users,
  Settings,
  ScrollText,
  FileText,
  ArrowLeft,
  Gamepad2,
  Music,
  Store,
  Bug,
  CreditCard,
  Mail,
  UserPlus,
} from 'lucide-react';
import { cn } from '../../lib/utils';

const adminNav = [
  { key: 'admin_dashboard', path: '/admin', icon: LayoutDashboard },
  { key: 'admin_users', path: '/admin/users', icon: Users },
  { key: 'admin_campaigns', path: '/admin/campaigns', icon: ScrollText },
  { key: 'admin_game_systems', path: '/admin/game-systems', icon: Gamepad2 },
  { key: 'admin_settings', path: '/admin/settings', icon: Settings },
  { key: 'admin_audit_logs', path: '/admin/audit-logs', icon: FileText },
  { key: 'admin_audio', path: '/admin/audio', icon: Music, label: 'Musiques' },
  { key: 'admin_marketplace', path: '/admin/marketplace', icon: Store },
  { key: 'admin_subscriptions', path: '/admin/subscriptions', icon: CreditCard, label: 'Abonnements' },
  { key: 'admin_email_templates', path: '/admin/email-templates', icon: Mail },
  { key: 'admin_beta_signups', path: '/admin/beta-signups', icon: UserPlus, label: 'Waitlist beta' },
  { key: 'admin_reports', path: '/admin/reports', icon: Bug },
];

export const AdminLayout = ({ children }) => {
  const { language } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="flex">
        {/* Sidebar */}
        <aside className="hidden lg:flex w-64 flex-col border-r border-border bg-card min-h-[calc(100vh-4rem)] p-4 gap-1">
          <Button
            variant="ghost"
            className="justify-start mb-4 text-muted-foreground"
            onClick={() => navigate('/dashboard')}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            {t('admin_back_to_site', language)}
          </Button>

          {adminNav.map((item) => {
            const Icon = item.icon;
            const isActive = item.path === '/admin'
              ? location.pathname === item.path
              : location.pathname.startsWith(item.path);
            const label = item.label || t(item.key, language);
            return (
              <Link key={item.path} to={item.path}>
                <Button
                  variant={isActive ? 'secondary' : 'ghost'}
                  className={cn('w-full justify-start', isActive && 'font-semibold')}
                >
                  <Icon className="mr-2 h-4 w-4" />
                  {label}
                </Button>
              </Link>
            );
          })}
        </aside>

        {/* Mobile nav */}
        <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-card p-2 flex gap-1 overflow-x-auto scrollbar-hide" style={{ WebkitOverflowScrolling: 'touch' }}>
          {adminNav.map((item) => {
            const Icon = item.icon;
            const isActive = item.path === '/admin'
              ? location.pathname === item.path
              : location.pathname.startsWith(item.path);
            return (
              <Link key={item.path} to={item.path}>
                <Button
                  variant="ghost"
                  size="icon"
                  className={cn(isActive && 'bg-secondary')}
                >
                  <Icon className="h-5 w-5" />
                </Button>
              </Link>
            );
          })}
        </div>

        {/* Main content */}
        <main className="flex-1 p-6 pb-20 lg:pb-6 max-w-6xl">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
